import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { UserUpsertModalDataFacade } from './infrastructure/user-upsert-modal-data.facade';
import { UsersEffects } from './state/users.effects';
import { UsersFacade } from './state/users.facade';
import { featureKey, reducer } from './state/users.reducer';

@NgModule({
    imports: [CommonModule, StoreModule.forFeature(featureKey, reducer), EffectsModule.forFeature([UsersEffects])],
    providers: [UsersFacade, UserUpsertModalDataFacade]
})
export class UsersDomainModule {}
